var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeoplesTwo = function SvgPeoplesTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.22a3.5 3.5 0 1 0 0-6.998 3.5 3.5 0 0 0 0 6.999v0ZM6 3.848a3.498 3.498 0 0 0 .196 5.873M18 3.848a3.495 3.495 0 0 1 1.5 2.873c0 1.189-.593 2.24-1.5 2.872M6 20.22v1h12v-1c0-1.863 0-2.795-.305-3.53a4 4 0 0 0-2.164-2.164c-.735-.305-1.667-.305-3.531-.305s-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C6 17.425 6 18.357 6 20.22ZM22 21.221v-.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.749M2 21.221v-.6c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPeoplesTwo;